import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  nextTick,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  ref
} from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'

type SkillItem = {
  skillname?: string
  years?: number | string
  description?: string
  uuid?: string
}

type FormLibWithCharCount = {
  charCount: (value: unknown) => number
}

type ElFormLike = {
  validate: () => Promise<unknown>
}

type ElInputLike = {
  resizeTextarea?: () => void
  $el?: { offsetHeight?: number }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryItemSkill',
  props: {
    item: null,
    index: null,
    length: null,
    descriptionPlaceholder: null,
    descriptionPlaceholder2: null,
    descriptionMaxLength: null,
    minYear: null,
    maxYear: null
  },
  emits: ["add-history-item", "delete-history-item", "move-history-item"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'add-history-item', index: number, item?: SkillItem): void
  (e: 'delete-history-item', index: number): void
  (e: 'move-history-item', params: { index: number; to: string }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: SkillItem
  index: number
  length: number
  descriptionPlaceholder?: string
  descriptionPlaceholder2?: string
  descriptionMaxLength?: number
  minYear?: number | string
  maxYear?: number | string
};





const { formLib } = useHostServices()
const formLibChars = formLib as typeof formLib & FormLibWithCharCount
const historyItemForm = ref<ElFormLike | null>(null)
const desc = ref<ElInputLike | ElInputLike[] | null>(null)
const errors = ref<string[]>([])

const editableItem = computed(() => props.item)
const computedMaxYear = computed(() =>
  props.maxYear ? Number(props.maxYear) : new Date().getFullYear() + 3
)

function charTooLong(value: unknown, max: number) {
  return formLibChars.charCount(value) > max
}

const rules = {
  year: [
    {
      validator: (
        _rule: unknown,
        value: unknown,
        callback: (err?: Error) => void
      ) => {
        if (charTooLong(value, 6)) callback(new Error('Please input digits'))
        else callback()
      },
      message: '年が長すぎます',
      trigger: ['change', 'blur']
    }
  ],
  month: [
    {
      validator: (
        _rule: unknown,
        value: unknown,
        callback: (err?: Error) => void
      ) => {
        if (charTooLong(value, 4)) callback(new Error('Please input digits'))
        else callback()
      },
      message: '月が長すぎます',
      trigger: ['change', 'blur']
    }
  ],
  description: [
    {
      validator: (
        _rule: unknown,
        value: unknown,
        callback: (err?: Error) => void
      ) => {
        if (charTooLong(value, props.descriptionMaxLength || 0)) {
          callback(new Error('Please input digits'))
        } else callback()
      },
      message:
        '一行におさまる文字数をオーバーしています。文章を短くするか、行を ＋ で追加して入力してください。',
      trigger: ['change', 'blur']
    }
  ]
}

function handleCommand(command: string) {
  if (command === 'addAbove') emit('add-history-item', props.index)
  else if (command === 'addBelow') emit('add-history-item', props.index + 1)
  else if (command === 'delete') emit('delete-history-item', props.index)
  else if (command === 'duplicate') {
    emit('add-history-item', props.index, props.item)
  } else if (command === 'moveUp') {
    emit('move-history-item', { index: props.index, to: 'up' })
  } else if (command === 'moveDown') {
    emit('move-history-item', { index: props.index, to: 'down' })
  }
}

function deactivateHistoryItem() {
  emitter.emit('deactivate-history-item')
}

function resizeDesc() {
  nextTick(() => {
    const target = Array.isArray(desc.value) ? desc.value[0] : desc.value
    if (target && typeof target.resizeTextarea === 'function') {
      if (target.$el && target.$el.offsetHeight) target.resizeTextarea()
    }
  })
}

onBeforeMount(() => {
  nextTick(() => {
    if (!historyItemForm.value) return
    historyItemForm.value
      .validate()
      .then()
      .catch(() => {})
  })
})

onMounted(() => {
  emitter.on('card-changed', resizeDesc)
})

onBeforeUnmount(() => {
  emitter.off('card-changed', resizeDesc)
})

return { __sfc: true,props, emit, formLib, formLibChars, historyItemForm, desc, errors, editableItem, computedMaxYear, charTooLong, rules, handleCommand, deactivateHistoryItem, resizeDesc }
}

})